var _path, _rect, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStreetview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 13.2222C25.5 15.7629 24.0917 18.0932 22.619 19.826C21.8888 20.6852 21.1573 21.3802 20.6083 21.8604C20.3628 22.0751 20.1544 22.2462 20 22.3692C19.8456 22.2462 19.6372 22.0751 19.3917 21.8604C18.8427 21.3802 18.1112 20.6852 17.381 19.826C15.9083 18.0932 14.5 15.7629 14.5 13.2222C14.5 10.0446 16.9794 7.5 20 7.5C23.0206 7.5 25.5 10.0446 25.5 13.2222Z",
    stroke: "currentColor"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 13.5,
    width: 6,
    height: 1,
    rx: 0.5,
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8296 32.1035V32.8066H8.62256V32.1035H11.7954V30.7236H9.50146V28.2188H14.1245V27.1113H9.48389V26.4258H14.9507V28.8867H10.3276V30.0381H15.1353V30.7236H12.6216V32.1035H15.8296ZM22.7817 29.6074V30.293H17.2974V26.5752H22.7114V27.2607H18.1235V29.6074H22.7817ZM16.4009 32.71V32.0156H23.6079V32.71H16.4009ZM31.3774 30.4248V31.1104H29.6108V33.7471H28.7759V31.1104H26.7808V33.7471H25.9282V31.1104H24.1704V30.4248H31.3774ZM25.0669 29.5547V26.1797H25.8931V27.1816H29.6372V26.1797H30.4722V29.5547H25.0669ZM25.8931 28.8867H29.6372V27.8408H25.8931V28.8867Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreetview);
export default __webpack_public_path__ + "static/media/streetview.226b28b8241b17b17a563063540610ee.svg";
export { ForwardRef as ReactComponent };